import React from 'react'

import { useDashboardPermissions } from '@components/utils/DashboardPermissions'
import { HeadContent } from '@fourthwall/components'

import { HMAC } from './modules/HMAC'
import { Headless } from './modules/Headless'
import { OpenAPI } from './modules/OpenAPI'
import { Webhooks } from './modules/Webhooks'

export const ForDevelopers = () => {
  const { hasPermission } = useDashboardPermissions()

  return (
    <>
      <HeadContent title="For developers &ndash; Settings" />

      {hasPermission('settings.forDevelopers.openAPI') && <OpenAPI />}

      {hasPermission('settings.forDevelopers.webhooks') && <Webhooks />}

      {hasPermission('settings.forDevelopers.headless') && <Headless />}

      {hasPermission('settings.forDevelopers.hmac') && <HMAC />}
    </>
  )
}
